import React from 'react';

import { IAssigneeOptionsList, useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { OptionsWithAssignee } from 'components/common/MyCustomSelect/components/OptionsWithAssignee/OptionsWithAssignee';

import { Select } from 'components/DesignSystem/Select';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AssigneeSelect = React.forwardRef<any, any>(({ ...rest }, ref) => {
    const { options } = useAssigneeOptionsList();
    return (
        <Select<IAssigneeOptionsList>
            {...rest}
            options={options}
            components={{
                Option: OptionsWithAssignee,
            }}
        />
    );
});
